import React from 'react'
import { makeStyles } from '@mui/styles'

import Footer from './mainFooter'

const MainWrapper = (props) => {
  const { heading, title, text, children, onBackButtonClick = null, disabled, onNextButtonClick, onAbortButtonClick, hidePrevButton } = props
  const classes = useStyles()

  return (
    <div className={classes.main}>
      <div className={classes.container}>
        <span className={classes.heading}>{heading}</span>
        <p className={classes.title}>{title}</p>
        {text && <p className={classes.text} dangerouslySetInnerHTML={{ __html: text }} />}
        {children}
      </div>
      <Footer
        hidePrevButton={hidePrevButton}
        onAbortButtonClick={onAbortButtonClick}
        onBackButtonClick={onBackButtonClick}
        disabled={disabled}
        onNextButtonClick={onNextButtonClick}
      />
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  main: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    overflow: 'auto',
    '@media (min-width: 800px)': {
      width: 570,
    },
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 1,
    width: '100%',
    maxWidth: 570,
    position: 'unset',
    padding: '30px 20px 0px 20px',
    '@media (min-width: 800px)': {
      position: 'initial',
      maxWidth: 'unset',
      padding: '40px 40px 0 40px',
    },
  },
  heading: {
    textTransform: 'uppercase',
    color: theme.primary,
    fontSize: 14,
    lineHeight: '17px',
    marginBottom: 20,
    '@media (min-width: 800px)': {
      display: 'none',
    },
  },
  title: {
    color: '#282828',
    fontSize: 24,
    lineHeight: '34px',
    letterSpacing: 0.48,
    marginTop: 0,
    marginBottom: 15,
    textAlign: 'center',
    '@media (min-width: 800px)': {
      fontSize: 24,
      lineHeight: '26px',
      letterSpacing: 0.24,
    },
  },
  text: {
    textAlign: 'center',
    fontSize: 16,
    lineHeight: '26px',
    letterSpacing: 0.32,
    marginBottom: 30,
    marginTop: 0,
    '@media (min-width: 800px)': {
      fontSize: 14,
      letterSpacing: 0.14,
    },
  },
}))

export default MainWrapper
